import { render, staticRenderFns } from "./BaseFilter.vue?vue&type=template&id=10369dfa&scoped=true&"
import script from "./BaseFilter.vue?vue&type=script&lang=js&"
export * from "./BaseFilter.vue?vue&type=script&lang=js&"
import style0 from "./BaseFilter.vue?vue&type=style&index=0&id=10369dfa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10369dfa",
  null
  
)

export default component.exports